<template>
  <div>

    <div v-if="dSites" class="alert alert-primary">
      <strong>{{dSites[iSites[$route.params.site]].name}}</strong>
    </div>

    <div style="padding-left: 5px; padding-bottom: 10px" v-if="callbells.count">
        <input type="number" style="width:7ch;height:21px;" v-model="callbells.year"/>
        <select v-model="callbells.month">
          <option v-for="option in callbells.months" v-bind:value="option" :key="option">{{ option }}</option>
        </select>
        <button class="badge badge-success" @click="callbellData('grf')">{{$t('callbell.btn.grf')}}</button>
        <button class="badge badge-success" @click="callbellData('csv')">{{$t('common.exportCsv')}}</button>
        <button v-if="!listView" @click="listView = true" class="badge badge-danger btn-ur">{{$t('common.close')}}</button>
    </div>

    <div v-if="!listView"><Charts :chartDev="chartDev" @close="listView = true"/></div>
    <div  v-if="listView" class="row">
      <div class="col-sm-6 mb-3" v-for="device in devices" :key="device.id">
        <div class="card text-white bg-dark" v-if="device.deviceVisible">
          <div class="card-body">
            <h5 class="card-title" v-on:click="toggle(device.id)">
              <img :src="getIcon(device)" class="dev-icon"/>
              <img v-if="device.data.type != 'callbell' && !device.contentVisible" class="btn-ur" src="/static/img/circled_plus.svg"/>
              <img v-if="device.data.type != 'callbell' && device.contentVisible" class="btn-ur" src="/static/img/circled_minus.svg"/>
              <input type="checkbox" v-if="'checked' in device.data" v-model="device.data.checked"/>
              {{device.data.name}}
              <br/><span :class="device.data.remarkClasses">{{device.data.remark}}</span>
            </h5>
            <div v-if="device.contentVisible">
              <table width="100%">
                <tbody>
                  <tr v-for="(row, i) in device.data.rows" :key="device.id+'_'+i">
					<template v-if="row.val || !row.hideIfNaN">
                    <td v-html="row.label"></td>
                    <td v-if="!(device.editform && row.edit)">{{row.val == null ? '' : Math.round(row.val * 1e3) / 1e3}} {{row.unit}}</td>
                    <td v-if="device.editform && row.edit"><input type="number" style="width:7ch;" v-model="row.val"/> {{row.unit}}</td>
					</template>
                  </tr>
                  <tr v-if="device.data.type == 'dishwasher'">
                    <td></td>
                    <td>
                      <button v-if="!device.editform" class="btn btn-danger" v-on:click="device.editform = true">{{$t('common.update')}}</button>
                      <button v-if="device.editform" class="btn btn-success" v-on:click="device.editform = false">{{$t('common.cancel')}}</button>
                      <button v-if="device.editform" class="btn btn-danger" v-on:click="saveDishwasherChanges(device)">{{$t('common.save')}}</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="device.flash" @click="device.flash = null" class="alert alert-success alert-dismissible upper-space" role="alert">
                {{device.flash}}
                <button type="button" class="close" data-dismiss="alert">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div v-if="device.data.type == 'dishwasher'" class="upper-space">
                <button class="btn btn-primary btn-block" v-on:click="showCsvExportModal(device.id)">{{$t('common.exportCsv')}}</button>
                <button class="btn btn-primary btn-block" v-on:click="openChart(device.id,'DishwasherHourly')">{{$t('dishwasher.btn.gHourly')}}</button>
                <button class="btn btn-primary btn-block" v-on:click="openChart(device.id,'Dishwasher100Cycles')">{{$t('dishwasher.btn.g100')}}</button>
                <button class="btn btn-primary btn-block" v-on:click="saveDishwasherCanisterChange(device)">{{$t('dishwasher.btn.canister')}}</button>
              </div>
              <div v-if="device.data.type == 'fridge'" class="upper-space">
                <button class="btn btn-primary btn-block" v-on:click="openChart(device.id,'Fridge')">{{$t('dishwasher.btn.gHourly')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="csvExportDialog" hide-footer v-bind:title="$t('dishwasher.xportPeriod')">
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input
              id="csvExport0"
              v-model="csvExport.d[0]"
              type="text"
              placeholder="YYYY-MM-DD"
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="csvExport.d[0]"
                button-only
                right
                locale="en-US"
                aria-controls="csvExport0"
              ></b-form-datepicker>
            </b-input-group-append">
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-form-input
              id="csvExport1"
              v-model="csvExport.d[1]"
              type="text"
              placeholder="YYYY-MM-DD"
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="csvExport.d[1]"
                button-only
                right
                locale="en-US"
                aria-controls="csvExport1"
              ></b-form-datepicker>
            </b-input-group-append">
          </b-input-group>
        </b-col>
      </b-row>
      <br/>
      <button class="btn btn-success" @click="hideCsvExportModal">{{$t('common.cancel')}}</button>
      <button v-if="!csvExport.loading" class="btn btn-danger" @click="dishWasherCsvInit">{{$t('common.exportCsv')}}</button>
      <button v-if="csvExport.loading" class="btn btn-danger" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{$t('common.exportCsv')}}
      </button>
    </b-modal>

  </div>
</template>

<script>

const fields = {
  dishwasher: [
    { i18n: 'washCycles' },
    { var: 'washCyclesLCleaning', tabs: 1 },
    { var: 'washCyclesToday', tabs: 1 },
    { var: 'washCyclesLDetergent', tabs: 1 },
    { var: 'washCyclesThisM', tabs: 1 },
    { var: 'washCyclesLastM', tabs: 1 },
    { var: 'boilerT', unit: '°C' },
    { var: 'washingTankT', unit: '°C' },
    { i18n: 'waterCons' },
    { var: 'waterConsThisM', unit: 'm³', tabs: 1 },
    { var: 'waterConsLastM', unit: 'm³', tabs: 1 },
    { i18n: 'elecCons' },
    { var: 'electricity', unit: 'kW/h', tabs: 1, hideIfNaN: true },
    { var: 'elecConsThisM', unit: 'kW/h', tabs: 1 },
    { var: 'elecConsLastM', unit: 'kW/h', tabs: 1 },
    { var: 'detergentConcentration', unit: 'mg/l', edit: 1},
    { var: 'detergentCanisterWeight', unit: 'kg', edit: 1}
  ],
  fridge: [
    { var: 'doorOpen', bool: true },
    { var: 'fridgeT', unit: '°C' },
    { var: 'condT', unit: '°C' }
  ],
  callbell: []
}

import Datepicker from 'vuejs-datepicker'
import db from '@/firebase/init'
import Charts from '@/components/Charts'
import SitesVars from '../mixins/SitesVars'

import Callbell from '@/components/Devices/Callbell'
import Dishwasher from '@/components/Devices/Dishwasher'

export default {
  name: 'Devices',
  mixins: [Callbell, Dishwasher, SitesVars],
  components: { Charts, Datepicker },
  data () {
    return {
      devices: [],
      devicesIndex: {},
      listView: true,
      chartDev: {
        id: null,
        name: null,
        type: null
      }
    }
  },

  methods: {

    toggle(id) {
      if(this.devices[this.devicesIndex[id]].data.type != 'callbell') {
        this.devices[this.devicesIndex[id]].contentVisible = !this.devices[this.devicesIndex[id]].contentVisible
      }
    },

    getIcon(device) {
      var type = device.data.type
      var suffix = []

      if('doorOpen' in device.data.indicators && device.data.indicators.doorOpen) { suffix.push('d') }

      if('canister' in device.data.indicators) {
        suffix.push(device.data.indicators.canister.substr(0,1).toUpperCase())
        type = 'canister'
      }

      suffix.sort()
      return '/static/img/' + type + (suffix.length ? '_' + suffix.join() : '') + '.svg'
    },

    openChart(id,type) {
      this.chartDev.id = id
      this.chartDev.name = id === null ? null : this.devices[this.devicesIndex[id]].data.name
      this.chartDev.type = type
      var charts = this.$refs.charts //TODO: remove
      this.listView = false
    },

    downloadCsv(rows, fileNamePrefix = 'skexport_') {
      const delimiter = ';'
      let csvContent = "data:text/csv;charset=utf-8,\ufeff";
      let row, len0, len1
      for(let i in rows) {
          row = ''
          for(let j in rows[i]) {
            row += (j>0 ? delimiter : '')
              + (typeof rows[i][j] == 'string' 
                && (rows[i][j].indexOf('"') > -1 || rows[i][j].indexOf(delimiter) > -1)
              ? '"' + rows[i][j].replace(/"/g, '""') + '"'
              : rows[i][j])
          }
          len0 = row.length
          for(let j = len0 - 1; j > -1; j--) {
            len1 = j
            if(row.charAt(j) != delimiter) { break; }
          }
          csvContent += (len1 < len0 - 1 ? row.substr(0, len1 + 1) : row) + "\r\n"
      }
      let link = document.getElementById("downloadLink")
      link.setAttribute("href", encodeURI(csvContent));
      link.setAttribute("download", fileNamePrefix + (new Date()).toISOString().substr(0,19).replace('T','_').replace(':','-').replace(':','-') + '.csv');
      link.click();
    }

  },

  created() {

    this.dataInitSites(false)

    db.collection('devices').where('siteId', '==', this.$route.params.site).onSnapshot((snapshot) => {
      var indicatorFields = ['doorOpen','canister']
      snapshot.docChanges().forEach((change) => {
        if(change.type == 'removed') {
          this.devices[this.devicesIndex[change.doc.id]].deviceVisible = false
        } else {
          var dat = {
            rows: [],
            index: {},
            name: change.doc.data().name, 
            type: change.doc.data().type,
            indicators: {}
          }

          if(dat.type == 'callbell') {
            this.callbells.count++
            dat.checked = true
          }

          if('status' in change.doc.data()) {

            for(var i in indicatorFields) {
              if(indicatorFields[i] in change.doc.data().status) {
                dat.indicators[indicatorFields[i]] = change.doc.data().status[indicatorFields[i]]
              }
            }

            if('fridgeT' in change.doc.data().status) {
              dat.remark = change.doc.data().status.fridgeT + ' °C'
            }

          }

          for(var i = 0; i < fields[change.doc.data().type].length; i++) {
            if('var' in fields[change.doc.data().type][i]) {
              //if(fields[change.doc.data().type][i].var in change.doc.data().status) {
                var row = {}
                row.label = this.$t(change.doc.data().type+'.'+fields[change.doc.data().type][i].var)
                if('tabs' in fields[change.doc.data().type][i]) { row.label = '&nbsp;&nbsp;&nbsp;' + row.label }
                row.val = change.doc.data().status[fields[change.doc.data().type][i].var];
                if('bool' in fields[change.doc.data().type][i]) { row.val = this.$t('common.' + (row.val ? 'Y' : 'N')) }
                row.unit = ('unit' in fields[change.doc.data().type][i]) ? fields[change.doc.data().type][i].unit : ''
                row.edit = 'edit' in fields[change.doc.data().type][i]
                row.hideIfNaN = 'hideIfNaN' in fields[change.doc.data().type][i]
                dat.rows.push(row)
                dat.index[''+fields[change.doc.data().type][i].var] = dat.rows.length - 1
              //}
            } else {
              dat.rows.push({
                label: this.$t(change.doc.data().type+'.'+fields[change.doc.data().type][i].i18n),
              })
            }
          }

          if(change.doc.id in this.devicesIndex) {
            this.devices[this.devicesIndex[change.doc.id]].data = dat
          } else {
            this.devicesIndex[change.doc.id] = this.devices.length
            this.devices.push({
              id: change.doc.id,
              contentVisible: false,
              deviceVisible: true,
              editform: false,
              data: dat,
              flash: null
            })
          }
        }
      })
    })
  }

}
</script>

<style>

.dev-icon {
    float: left;
    margin-right: 8px;
    margin-bottom: 8px;
}

.btn-ur {
  float: right;
  margin-left: 5px;
}

.upper-space {
  margin-top: 10px
}

.vjsdp-wrap {
  display: inline-block; 
}

.vjsdp-input {
  width: 10ch;
  height: 21px;
}

</style>



// WEBPACK FOOTER //
// src/components/Devices.vue